import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import validateField from "../utils/fieldValidator";

function SimpleFormModal({
  isOpen,
  title,
  initialData,
  fields,
  onSave,
  onCancel
}) {

  const getInitialFormState = useCallback(() => {
    const state = {};
    fields.forEach((field) => {
      if (initialData && initialData[field.name] !== undefined) {
        if (initialData[field.name] === null) {
          state[field.name] = "";
        } else {
          state[field.name] = initialData[field.name];
        }
      } else {
        state[field.name] = "";
      }
    });
    return state;
  }, [fields, initialData]);

  const [formData, setFormData] = useState(getInitialFormState());
  const [errors, setErrors] = useState({});
  const firstInputRef = useRef(null);

  useEffect(() => {
    setFormData(getInitialFormState());
    setErrors({});
  }, [getInitialFormState, isOpen]);

  function handleChange(e) {
    const { name, value } = e.target;
    const errorMessage = validateField(name, value);

    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
  }

  function handleSubmit() {
    const dataToSubmit = {};

    fields.forEach((field) => {
      let value = formData[field.name] || "";
      if (field.type === "number") {
        value = parseFloat(value);
      }
      dataToSubmit[field.name] = value;
    });

    const newErrors = {};
    fields.forEach((field) => {
      const errorMessage = validateField(field.name, dataToSubmit[field.name]);
      if (errorMessage) {
        newErrors[field.name] = errorMessage;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    onSave(dataToSubmit);
  }



  return (
    <Modal
      backdrop="static"
      keyboard={false}
      isOpen={isOpen}
      toggle={onCancel}
    >
      <ModalHeader
        toggle={onCancel}
        close={
          <FontAwesomeIcon
            color="black"
            icon="times"
            size="2x"
            onClick={onCancel}
          />
        }
      >
        {title}
      </ModalHeader>
      <ModalBody>
        <Form>
          {fields.map((field, index) => {
            return (
              <FormGroup key={field.name}>
                <Label for={field.name} style={{ display: "block" }}>
                  {field.label}
                </Label>
                <Input
                  aria-label={field.label}
                  className="form-control"
                  innerRef={index === 0 ? firstInputRef : null}
                  type={field.type}
                  name={field.name}
                  id={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  invalid={!!errors[field.name]}
                />
                {errors[field.name] && (
                  <FormFeedback>{errors[field.name]}</FormFeedback>
                )}
              </FormGroup>
            );
          })}

        </Form>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="mt-2 d-flex justify-content-end">
            <Button color="secondary" onClick={onCancel} style={{ marginRight: "1rem" }}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSubmit}>
              OK
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default SimpleFormModal;